export default {"src":"/_next/static/media/getasugarLogo.ab4534cc.svg","height":182,"width":950,"blurWidth":0,"blurHeight":0};